import { render, staticRenderFns } from "./DefaultLayoutFluid.vue?vue&type=template&id=3165c960&"
import script from "./DefaultLayoutFluid.vue?vue&type=script&lang=js&"
export * from "./DefaultLayoutFluid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports